import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { isConfigurationComplete } from './config/aws-config';

// Check if AWS configuration is complete
if (!isConfigurationComplete()) {
  console.warn(
    'AWS configuration is incomplete. Some features may not work properly. ' +
    'Please run the setup script: ./scripts/setup-frontend-config.sh'
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);